<template>
  <h3 class="pb5">Réclamation des Enquêtes (CDX_0030)</h3>
  <CritereRechercheLoteries :onlyShowDate="true" :showDateEtLe="false"
                            ref="critereRechercheLoteries"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import CritereRechercheLoteries from "@/components/rapports/Rechercher/CritereRechercheLoteries.vue";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "EnqueteReclamationCDX_0030",
  components: {CritereRechercheLoteries, ButtonBar},
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Loteries");
    this.$refs.critereRechercheLoteries.dateDefault();
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      var criteresRapportVO = this.$refs.critereRechercheLoteries.getCritereRecherche();
      criteresRapportVO.titre = "EnqueteReclamationDossierGenerateurRapport_CDX_0030";
      criteresRapportVO.nomRapport = "loteries.EnqueteReclamationDossierGenerateurRapport_CDX_0030";
      this.$store.dispatch("rapports/obtenirRapportAction",
          criteresRapportVO
      )
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
}
</script>

<style scoped>

</style>